import { FileEntryDownloadDto, PlaylistContentDownloadDto, PostDownloadDto } from 'collaboration-service';
import { Button, ButtonProps, Icon, Tooltip } from 'imaginarity-react-ui';
import * as React from 'react';
import { useAppSelector } from 'services/ApplicationState/ApplicationState';
import { getCMSContent } from 'services/Helpers/TranslationHelpers';
import { useImgI18N } from 'services/ImgI18N';
import { CSTitle, CSTitleIcon, CSTitleInfo, CSTitleInfoContainer, CurSeqDetailContainer, CurSeqDetailContainerOuter, NodeConnectorHleft, SMIEContainer, SMIECTitle } from './PlaylistEditClasses';
import { getPlaylistContentData } from './PlaylistEditContentImplementedElement';
import PlaylistEditPreviewElement from './PlaylistEditPreviewElement';
import { documentKindByType } from '../PlaylistItems/PlaylistNodeItem';

export interface PlaylistEditSequenceImplementedElementProps {
    content: PlaylistContentDownloadDto;
    post: PostDownloadDto;
    notUsed?: boolean;
    numberOfUsed?: number;
    moveUp?: () => void;
    moveDown?: () => void;
    toggleHidden?: (hidden: boolean) => void;
    clickButtonProps?: Omit<ButtonProps, "kind">;
    isLinear?: boolean;
    isAllAtOnce?: boolean;
    expandedView?: boolean;
    select?: () => void;
    fullWidth?: boolean;
    borderColor?: string;
}

const PlaylistEditSequenceImplementedElement = (p: PlaylistEditSequenceImplementedElementProps) => {
    const { content, post, toggleHidden, moveDown, moveUp, clickButtonProps, isLinear, notUsed, numberOfUsed, isAllAtOnce, expandedView, select, fullWidth, borderColor } = p;
    const { t, currentLanguage } = useImgI18N("playlist");
    const contentLanguage = useAppSelector(s => s.contentLanguage);
    const hidden = content.hidden ?? false;
    const language = contentLanguage ?? currentLanguage;
    const contentFE = post?.type === "FileEntry" ? getCMSContent({ fileEntry: post as FileEntryDownloadDto, filePosts: {}, language }) : undefined;
    const eleType = post?.type === "FileEntry" ? documentKindByType(contentFE?.media?.mediaType) : undefined;

    const { icon, title } = React.useMemo(() => {
        return getPlaylistContentData(content, language, post);
    }, [content, language, post]);



    const toggleVisibility = () => {
        if (toggleHidden)
            toggleHidden(!hidden);
    }
    const u = numberOfUsed;

    const sanitizedTitle = title.replace(/<\/?p>/g, '');
    const isSmallView = !expandedView;
    const typeIsFileEntry = post.type === "FileEntry";

    const usedSeveralTimes = (numberOfUsed && numberOfUsed > 1);
    const usedOneTime = (numberOfUsed && numberOfUsed === 1);
    const itemColor = usedSeveralTimes ? "@accentOrange" : (notUsed ? "@accentBlue" : (usedOneTime ? "@lightGrey" : "@darkGrey"));

    return (
        <>
            {isSmallView && !isAllAtOnce ?
                <SMIEContainer title={sanitizedTitle} onClick={select} color={itemColor}>
                    <SMIECTitle>
                        {notUsed ?
                            <Icon name="exclamation" style={{ float: "left", marginRight: 5 }} size="14px" marginTop={1} />
                            :
                            <Icon name={icon} style={{ float: "left", marginRight: 5 }} size="14px" marginTop={2} />

                        }
                        {sanitizedTitle}
                    </SMIECTitle>
                    <Tooltip tooltipText={t('element is used {{count}} times in this playlist', { count: u })} noMargin position='top'>
                        <div style={{ paddingRight: clickButtonProps ? 5 : 10, textAlign: "right", fontSize: "smaller", fontWeight: "bolder" }}>
                            {u}
                        </div>
                    </Tooltip>
                    <div>
                        {clickButtonProps &&
                            <Button size="mini" floated='right' kind="transparentButton" {...clickButtonProps} tooltip={undefined} />
                        }
                    </div>
                </SMIEContainer>










                :
                <CurSeqDetailContainerOuter>
                    <CurSeqDetailContainer invisible={hidden} color={itemColor} fullWidth={fullWidth} borderColor={borderColor}>
                        {isLinear &&
                            <NodeConnectorHleft color={itemColor} />
                        }
                        <div style={{ display: "grid", gridTemplateColumns: `${typeIsFileEntry ? "45px" : "35px"} ${typeIsFileEntry ? "60px" : 0} 1fr max-content` }}>
                            <CSTitleIcon invisible={hidden}>
                                <Icon name={icon} style={{ float: "left", marginTop: 4, marginLeft: 10 }} />
                                {typeIsFileEntry &&
                                    <Icon name="chevron right" size="14px" style={{ float: "left", marginTop: 2 }} />
                                }
                            </CSTitleIcon>
                            <CSTitle style={{ padding: 0 }}>
                                {t(eleType ?? post.type ?? "unknown")}
                            </CSTitle>
                            <CSTitle style={{ paddingRight: isAllAtOnce ? 0 : 10 }} title={sanitizedTitle}>
                                {sanitizedTitle}
                            </CSTitle>
                            <div style={{ marginTop: -1 }}>
                                <PlaylistEditPreviewElement post={post} />
                                {notUsed ?
                                    <Button kind="transparentButton" icon="exclamation" iconColor='@accentBlue' floated='left' tooltip={{ tooltipText: t('element not in used in this playlist') }} />
                                    :
                                    <div style={{ float: "left", marginTop: 1 }}>
                                        {u ?
                                            <Tooltip tooltipText={t('element is used {{count}} times in this playlist', { count: u })} noMargin position='top'>
                                                <CSTitleInfoContainer>
                                                    <CSTitleInfo color={itemColor} >
                                                        <>{u}</>
                                                    </CSTitleInfo>
                                                </CSTitleInfoContainer>
                                            </Tooltip>
                                            :
                                            <div />
                                        }
                                    </div>
                                }
                                {clickButtonProps && <Button floated='left' kind={"transparentButton"} {...clickButtonProps} />}
                                {toggleHidden && <Button floated='left' icon={hidden ? "eye close" : "eye open"} kind="transparentButton" onClick={toggleVisibility} />}
                                {moveUp && <Button floated='left' icon="chevron up" kind="transparentButton" onClick={moveUp} />}
                                {moveDown && <Button floated='left' icon="chevron down" kind="transparentButton" onClick={moveDown} />}
                            </div>
                        </div>

                    </CurSeqDetailContainer>
                </CurSeqDetailContainerOuter>
            }
        </>
    );
}

export default PlaylistEditSequenceImplementedElement;
